import HeaderProps from "./_header-props";
import HeaderMobile from './_header-mobile'

class HeaderSearch {
    constructor() {
        if (!HeaderProps.$header) {
            return;
        }
        this.setup();
    }

    setup() {
        const $searchNav = HeaderProps.$header.querySelector("#search-nav");
        $searchNav.addEventListener("list-open", () => this.searchModeOn());
        $searchNav.addEventListener("list-closed", () => this.searchModeOff());
    }

    searchModeIsOn() {
        const $searchBar = HeaderProps.$header.querySelector(
            "[data-header-searchbar]",
        );
        return $searchBar?.getAttribute("data-header-searchbar") === "open";
    }

    searchModeOn() {
        const $searchBar = HeaderProps.$header.querySelector(
            "[data-header-searchbar]",
        );
        const $searchButton = HeaderProps.$header.querySelector(
            `[data-invoker="${this.getSearchToggle()}"]`,
        );
        const $searchInput = $searchBar.querySelector("[data-header-searchfield]");

        console.assert(
            $searchBar && $searchButton && $searchInput,
            "search not properly set up",
        );

        // explicitly mark searchbar as open
        $searchBar?.setAttribute("data-header-searchbar", "open");
        $searchButton?.setAttribute("aria-expanded", "true");

        // handle styles
        $searchBar?.classList?.remove("c-header__searchbar--collapsed");
        $searchButton?.classList?.add("c-header__search-button--active");

        // handle behavior
        $searchInput?.focus();

        if (matchMedia(`(max-width: ${HeaderProps.breakPoint})`).matches) {
            HeaderProps.$header.querySelector("#root-nav").setTransitionOut(false);
        }
    }

    searchModeOff() {
        const $searchBar = HeaderProps.$header.querySelector(
            "[data-header-searchbar]",
        );
        const $searchResults = HeaderProps.$header.querySelector(
            "[data-header-search-results]",
        );
        const $searchButton = HeaderProps.$header.querySelector(
            `[data-invoker="${this.getSearchToggle()}"]`,
        );

        console.assert(
            $searchBar && $searchButton && $searchResults,
            "search not properly set up",
        );

        $searchResults?.querySelector("[data-list-transition]").setTransitionOut();

        // explicitly mark searchbar as closed
        $searchBar?.setAttribute("data-header-searchbar", "closed");
        $searchButton?.setAttribute("aria-expanded", "false");

        // handle styles
        $searchBar?.classList.add("c-header__searchbar--collapsed");
        $searchButton?.classList.remove("c-header__search-button--active");
    }

    /**
     *
     * @returns {string}
     */
    getSearchToggle() {
        if(HeaderMobile.isMobile()) {
            return "search-button-mobile";
        } else {
            return "search-button";
        }
    }

    /*
     * Manually turn search mode off
     *
     * Because the searchModeOn and searchModeOff functions are triggered by the opening and closing events of
     * the list transitions. This function closes the list transition of the searchbar, which triggers the searchModeOff
     * function.
     *
     */
    manuallyTurnSearchModeOff() {
        const $searchNav = HeaderProps.$header.querySelector("#search-nav");
        $searchNav?.setTransitionOut(false);
    }
}

export default new HeaderSearch();
